// src/components/Spinner.jsx
import "./Spinner.css";
import football from "../assets/football.png";

export default function Spinner() {
  return (
    <div className="spinner-wrapper">
      <img src={football} alt="Carregando..." className="spinner-ball" />
    </div>
  );
}
